export function newFolder(state, name) {
  const id = state.nextId;
  return [
    { ...state, nextId: 1 + id },
    { id, name, children: [] },
  ];
}

export function cutFolder(state, folderId) {
  let folder = null;
  const newState = mutate(state, (node) => {
    if (node.id == folderId) {
      folder = node;
      return null;
    } else {
      return node;
    }
  });
  return [newState, folder];
}

export function mutate(state, mutator) {
  return {
    ...state,
    version: state.version + 1,
    tree: traverse(state.tree, mutator),
  };
}

function traverse(node, mutator) {
  return mutator({
    ...node,
    children: node.children
      .map((node) => traverse(node, mutator))
      .filter((node) => node != null),
  });
}
